import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a new password for your account."
      footer={<Link to="/login" className="text-cyan-300 hover:underline">Back to sign in</Link>}>
      {!token ? (
        <p className="text-sm text-red-300 text-center">This reset link is invalid. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {error && <div data-testid="reset-error" className="text-sm text-red-300 bg-red-500/10 rounded-lg px-3 py-2">{error}</div>}
          <div><Label className="text-slate-200 mb-1.5 block">New password</Label><Input data-testid="reset-password" type="password" required minLength={6} className="bg-white/5 border-white/10 text-white" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          <Button type="submit" data-testid="reset-submit" disabled={loading} className="w-full h-11 bg-violet-600 hover:bg-violet-500 text-white font-semibold">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
